export default "__VITE_ASSET__CK5tW4Rk__"